class swiperTabProduct extends HTMLElement {
  constructor() {
    super();
    this.tab = '';
    this.borderLine = this.querySelector('.border-line')
  }
  connectedCallback() {
    this.init();
    let tab = this.querySelectorAll('.swiper-tab span');
    let buttonLink = this.querySelector('#buttonLink1').innerText;
    if(tab.length > 1){
      tab.forEach((item,index)=>{
        item.addEventListener('click',(e)=>{this.tabClickEvent(e)})
        if(index == 0){
          this.tab = item.getAttribute("value");
          setTimeout(()=>{
            this.borderLine.style.transform = `translate3d(${item.offsetLeft}px,0,0)`
            this.borderLine.style.width = `${item.offsetWidth}px`
          },500)
        }
      })
    }
    setTimeout(()=>{
      this.productListSwiper();
      this.swiperIntersectionObserver();
      this.querySelector('.view-all .button') && this.querySelector('.view-all .button').setAttribute('href',buttonLink)
      this.querySelector('.view-all .button') && this.querySelector('.view-all .button').setAttribute('aria-label',`View all products in the ${this.tab} Collection collection`);
    },1000)
  }
  init(){
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.srcset = img && img.getAttribute('data-url');
            img.src = img && img.getAttribute('data-url');
            observer.unobserve(img);
          }
          else{
            entry.target.srcset = '';
            entry.target.src = '';
          }
        });
      });
      const lazyImages = this.querySelectorAll('.motion-reduce');
      lazyImages.forEach((img) => {
        observer.observe(img);
      });
  }
  productListSwiper(){
    let that = this;
    let swiperInfo = JSON.parse(this.querySelector('#swiperTabProductInfo').textContent);
    let width = document.documentElement.clientWidth;
    let isCustomView = this.querySelector('.swiper-tab-product-wrapper').getAttribute('data-custom-view')
    let custom = width > 1024 && width <= 1440 && isCustomView ? 5 : width > 1440 && isCustomView ? 6 : 4;
    let slidesPerView = width < 750 ? 'auto' : custom ;
    // console.log(slidesPerView,width,isCustomView,width > 1024,width <= 1440 , isCustomView)
    let spaceBetween = width < 750 ? 0 : width > 1440 || isCustomView && width > 1440 ? 24 : 18;
    let isButtonTop = this.querySelector('.title-wrapper');
    let nextEl = isButtonTop.getAttribute('data-button') ? isButtonTop.querySelector('.swiper-button-wrapper .swiper-button-next') : this.querySelector('.swiper-tab-product .swiper-button-next');
    let prevEl = isButtonTop.getAttribute('data-button') ? isButtonTop.querySelector('.swiper-button-wrapper .swiper-button-prev') : this.querySelector('.swiper-tab-product .swiper-button-prev');
    let scrollbar = swiperInfo.is_swiper_scrollbar ? {
      el:`.swiper-scrollbar-${this.dataset.sectionId}`
      
    }: false;
    let navigation = swiperInfo.is_button ? {
        nextEl,
        prevEl,
    } : {};
    new Swiper(`.swiper-tab-product-wrapper${this.dataset.sectionId}`,{
      loop: swiperInfo.is_loop,
      autoplay: swiperInfo.is_autoplay,
      observer: true, 
      observerParents: true,
      slidesPerView,
      slidesPerGroup:1,
      spaceBetween,
      allowTouchMove: swiperInfo.is_allowTouchMove,
      navigation,
      lazy: {
        loadPrevNext: true,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      on:{
        // init:function(){
        //     prevEl.style.opacity = '.35';
        //     prevEl.style.pointerEvents = 'none';
        //     nextEl.style.opacity = '1';
        //     nextEl.style.pointerEvents = 'unset';
        // },
        // slideNextTransitionEnd:function(){
        //    if(this.isEnd){
        //       nextEl.style.opacity = '.35';
        //       nextEl.style.pointerEvents = 'none';
        //       prevEl.style.opacity = '1';
        //       prevEl.style.pointerEvents = 'unset';
        //     }
        //     else if(this.isBeginning){
        //       prevEl.style.opacity = '.35';
        //       prevEl.style.pointerEvents = 'none';
        //       nextEl.style.opacity = '1';
        //       nextEl.style.pointerEvents = 'unset';
        //     }
        //     else{
        //       prevEl.style.opacity = '1';
        //       prevEl.style.pointerEvents = 'unset';
        //       nextEl.style.opacity = '1';
        //       nextEl.style.pointerEvents = 'unset';
        //     }
        // }
      }
    })
  }
  // navigationEvent(type,e){
  //   let nextEl = this.querySelector('.swiper-tab-product .swiper-button-next');
  //   let prevEl = this.querySelector('.swiper-tab-product .swiper-button-prev');
  //   type == 'next' ? e.slideTo(e.realIndex + 1,500,true) : e.slideTo(e.realIndex - 1,500,true);
  //   console.log(e.realIndex)
  //   if(e.isEnd){
  //       nextEl.style.opacity = '.35';
  //       nextEl.style.pointerEvents = 'none';
  //       prevEl.style.opacity = '1';
  //       prevEl.style.pointerEvents = 'unset';
  //     }
  //     else if(e.isBeginning){
  //       prevEl.style.opacity = '.35';
  //       prevEl.style.pointerEvents = 'none';
  //       nextEl.style.opacity = '1';
  //       nextEl.style.pointerEvents = 'unset';
  //     }
  //     else{
  //       prevEl.style.opacity = '1';
  //       prevEl.style.pointerEvents = 'unset';
  //       nextEl.style.opacity = '1';
  //       nextEl.style.pointerEvents = 'unset';
  //     }
  // }
  tabClickEvent(e){
    let tab = this.querySelectorAll('.swiper-tab span');
    // this.querySelector('.border-line').style.left = e.target.getBoundingClientRect().left + 'px';
    this.querySelector('.swiper-tab-product-wrapper-'+this.tab).classList.add('hidden');
    let buttonLink = this.querySelector('#buttonLink'+ e.target.getAttribute('data-index'));
    tab.forEach((item)=>{
      // item.style.borderBottom = 'none';
      item.style.color = '#787979'
      item.style.backgroundImage = 'linear-gradient(to top,#1E1F20 0px,#1E1F20 0px),linear-gradient(to top,transparent 0px,transparent 0px)'
    })
    this.borderLine.style.transform = `translate3d(${e.target.offsetLeft}px,0,0)`
    this.borderLine.style.width = `${e.target.offsetWidth}px`
    // e.target.style.borderBottom = '1px solid #1E1F20';
    e.target.style.color = '#1E1F20';
    e.target.style.backgroundImage = 'none'
    this.querySelector('.swiper-tab-product-wrapper-'+e.target.getAttribute("value")).classList.remove('hidden');
    this.tab = e.target.getAttribute("value");
    this.productListSwiper();
    this.querySelector('.view-all .button') && this.querySelector('.view-all .button').setAttribute('href',buttonLink.innerText)
    this.querySelector('.view-all .button') && this.querySelector('.view-all .button').setAttribute('aria-label',`View all products in the ${this.tab} Collection collection`)
  }
  swiperIntersectionObserver(){
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(item => {
            if(item.isIntersecting) {
                const img = item.target;
                img.src = img.dataset.src;
                observer.unobserve(item.target);
            }
            else{
              item.target.src = '';
            }
        })
    })
    const img = this.querySelectorAll('[data-src]')
    img.forEach(item => {
        observer.observe(item)
    })
  }
}
customElements.define('swiper-tab-product', swiperTabProduct);